var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 40,
    viewBox: "0 0 135 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 134,
    height: 39,
    rx: 4.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.136 21.7511C65.784 21.7511 63.867 23.5401 63.867 26.0041C63.867 28.4531 65.784 30.2571 68.136 30.2571C70.489 30.2571 72.406 28.4531 72.406 26.0041C72.405 23.5401 70.488 21.7511 68.136 21.7511ZM68.136 28.5831C66.847 28.5831 65.736 27.5201 65.736 26.0051C65.736 24.4741 66.848 23.4271 68.136 23.4271C69.425 23.4271 70.536 24.4741 70.536 26.0051C70.536 27.5191 69.425 28.5831 68.136 28.5831ZM58.822 21.7511C56.47 21.7511 54.553 23.5401 54.553 26.0041C54.553 28.4531 56.47 30.2571 58.822 30.2571C61.175 30.2571 63.092 28.4531 63.092 26.0041C63.092 23.5401 61.175 21.7511 58.822 21.7511ZM58.822 28.5831C57.533 28.5831 56.422 27.5201 56.422 26.0051C56.422 24.4741 57.534 23.4271 58.822 23.4271C60.111 23.4271 61.222 24.4741 61.222 26.0051C61.223 27.5191 60.111 28.5831 58.822 28.5831ZM47.744 23.0571V24.8611H52.062C51.933 25.8761 51.595 26.6171 51.079 27.1321C50.451 27.7601 49.468 28.4531 47.744 28.4531C45.086 28.4531 43.008 26.3101 43.008 23.6521C43.008 20.9941 45.086 18.8511 47.744 18.8511C49.178 18.8511 50.225 19.4151 50.998 20.1401L52.271 18.8671C51.191 17.8361 49.758 17.0471 47.744 17.0471C44.103 17.0471 41.042 20.0111 41.042 23.6521C41.042 27.2931 44.103 30.2571 47.744 30.2571C49.709 30.2571 51.192 29.6121 52.351 28.4041C53.543 27.2121 53.914 25.5361 53.914 24.1831C53.914 23.7651 53.882 23.3781 53.817 23.0561H47.744V23.0571ZM93.052 24.4581C92.698 23.5081 91.618 21.7511 89.411 21.7511C87.22 21.7511 85.399 23.4751 85.399 26.0041C85.399 28.3881 87.204 30.2571 89.62 30.2571C91.569 30.2571 92.697 29.0651 93.165 28.3721L91.715 27.4051C91.232 28.1141 90.571 28.5811 89.62 28.5811C88.67 28.5811 87.993 28.1461 87.558 27.2921L93.245 24.9401L93.052 24.4581ZM87.252 25.8761C87.204 24.2321 88.525 23.3951 89.476 23.3951C90.217 23.3951 90.845 23.7661 91.055 24.2971L87.252 25.8761ZM82.629 30.0001H84.497V17.4991H82.629V30.0001ZM79.567 22.7021H79.503C79.084 22.2021 78.278 21.7511 77.264 21.7511C75.137 21.7511 73.188 23.6201 73.188 26.0211C73.188 28.4051 75.137 30.2581 77.264 30.2581C78.279 30.2581 79.084 29.8071 79.503 29.2921H79.567V29.9041C79.567 31.5311 78.697 32.4011 77.296 32.4011C76.152 32.4011 75.443 31.5801 75.153 30.8871L73.526 31.5641C73.993 32.6911 75.233 34.0771 77.296 34.0771C79.487 34.0771 81.34 32.7881 81.34 29.6461V22.0101H79.568V22.7021H79.567ZM77.425 28.5831C76.136 28.5831 75.057 27.5031 75.057 26.0211C75.057 24.5221 76.136 23.4271 77.425 23.4271C78.697 23.4271 79.696 24.5221 79.696 26.0211C79.696 27.5031 78.697 28.5831 77.425 28.5831ZM101.806 17.4991H97.335V30.0001H99.2V25.2641H101.805C103.873 25.2641 105.907 23.7671 105.907 21.3821C105.907 18.9971 103.874 17.4991 101.806 17.4991ZM101.854 23.5241H99.2V19.2391H101.854C103.249 19.2391 104.041 20.3941 104.041 21.3821C104.041 22.3501 103.249 23.5241 101.854 23.5241ZM113.386 21.7291C112.035 21.7291 110.636 22.3241 110.057 23.6431L111.713 24.3341C112.067 23.6431 112.727 23.4171 113.418 23.4171C114.383 23.4171 115.364 23.9961 115.38 25.0251V25.1541C115.042 24.9611 114.318 24.6721 113.434 24.6721C111.649 24.6721 109.831 25.6531 109.831 27.4861C109.831 29.1591 111.295 30.2361 112.935 30.2361C114.189 30.2361 114.881 29.6731 115.315 29.0131H115.379V29.9781H117.181V25.1851C117.182 22.9671 115.524 21.7291 113.386 21.7291ZM113.16 28.5801C112.55 28.5801 111.697 28.2741 111.697 27.5181C111.697 26.5531 112.759 26.1831 113.676 26.1831C114.495 26.1831 114.882 26.3601 115.38 26.6011C115.235 27.7601 114.238 28.5801 113.16 28.5801ZM123.743 22.0021L121.604 27.4221H121.54L119.32 22.0021H117.31L120.639 29.5771L118.741 33.7911H120.687L125.818 22.0021H123.743ZM106.937 30.0001H108.802V17.4991H106.937V30.0001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4176 10.2429C47.4176 11.0809 47.1696 11.7479 46.6726 12.2459C46.1086 12.8379 45.3726 13.1339 44.4686 13.1339C43.6026 13.1339 42.8656 12.8339 42.2606 12.2339C41.6546 11.6329 41.3516 10.8889 41.3516 10.0009C41.3516 9.11194 41.6546 8.36794 42.2606 7.76794C42.8656 7.16694 43.6026 6.86694 44.4686 6.86694C44.8986 6.86694 45.3096 6.95094 45.6996 7.11794C46.0906 7.28594 46.4036 7.50894 46.6376 7.78794L46.1106 8.31594C45.7136 7.84094 45.1666 7.60394 44.4676 7.60394C43.8356 7.60394 43.2896 7.82594 42.8286 8.26994C42.3676 8.71394 42.1376 9.29094 42.1376 9.99994C42.1376 10.7089 42.3676 11.2859 42.8286 11.7299C43.2896 12.1739 43.8356 12.3959 44.4676 12.3959C45.1376 12.3959 45.6966 12.1729 46.1436 11.7259C46.4336 11.4349 46.6016 11.0299 46.6466 10.5109H44.4676V9.78994H47.3746C47.4046 9.94694 47.4176 10.0979 47.4176 10.2429Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0277 7.737H49.2957V9.639H51.7597V10.36H49.2957V12.262H52.0277V13H48.5247V7H52.0277V7.737Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2785 13H54.5075V7.737H52.8315V7H56.9545V7.737H55.2785V13Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9375 13V7H60.7085V13H59.9375Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1277 13H63.3567V7.737H61.6807V7H65.8037V7.737H64.1277V13Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6084 12.225C73.0184 12.831 72.2854 13.134 71.4084 13.134C70.5314 13.134 69.7984 12.831 69.2094 12.225C68.6194 11.619 68.3254 10.877 68.3254 9.99999C68.3254 9.12299 68.6194 8.38099 69.2094 7.77499C69.7984 7.16899 70.5314 6.86499 71.4084 6.86499C72.2804 6.86499 73.0124 7.16999 73.6044 7.77899C74.1964 8.38799 74.4924 9.12799 74.4924 9.99999C74.4924 10.877 74.1974 11.619 73.6084 12.225ZM69.7784 11.722C70.2224 12.172 70.7654 12.396 71.4084 12.396C72.0514 12.396 72.5954 12.171 73.0384 11.722C73.4824 11.272 73.7054 10.698 73.7054 9.99999C73.7054 9.30199 73.4824 8.72799 73.0384 8.27799C72.5954 7.82799 72.0514 7.60399 71.4084 7.60399C70.7654 7.60399 70.2224 7.82899 69.7784 8.27799C69.3354 8.72799 69.1124 9.30199 69.1124 9.99999C69.1124 10.698 69.3354 11.272 69.7784 11.722Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5745 13V7H76.5125L79.4285 11.667H79.4615L79.4285 10.511V7H80.1995V13H79.3945L76.3435 8.106H76.3105L76.3435 9.262V13H75.5745Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4176 10.2429C47.4176 11.0809 47.1696 11.7479 46.6726 12.2459C46.1086 12.8379 45.3726 13.1339 44.4686 13.1339C43.6026 13.1339 42.8656 12.8339 42.2606 12.2339C41.6546 11.6329 41.3516 10.8889 41.3516 10.0009C41.3516 9.11194 41.6546 8.36794 42.2606 7.76794C42.8656 7.16694 43.6026 6.86694 44.4686 6.86694C44.8986 6.86694 45.3096 6.95094 45.6996 7.11794C46.0906 7.28594 46.4036 7.50894 46.6376 7.78794L46.1106 8.31594C45.7136 7.84094 45.1666 7.60394 44.4676 7.60394C43.8356 7.60394 43.2896 7.82594 42.8286 8.26994C42.3676 8.71394 42.1376 9.29094 42.1376 9.99994C42.1376 10.7089 42.3676 11.2859 42.8286 11.7299C43.2896 12.1739 43.8356 12.3959 44.4676 12.3959C45.1376 12.3959 45.6966 12.1729 46.1436 11.7259C46.4336 11.4349 46.6016 11.0299 46.6466 10.5109H44.4676V9.78994H47.3746C47.4046 9.94694 47.4176 10.0979 47.4176 10.2429Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0277 7.737H49.2957V9.639H51.7597V10.36H49.2957V12.262H52.0277V13H48.5247V7H52.0277V7.737Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2785 13H54.5075V7.737H52.8315V7H56.9545V7.737H55.2785V13Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9375 13V7H60.7085V13H59.9375Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1277 13H63.3567V7.737H61.6807V7H65.8037V7.737H64.1277V13Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6084 12.225C73.0184 12.831 72.2854 13.134 71.4084 13.134C70.5314 13.134 69.7984 12.831 69.2094 12.225C68.6194 11.619 68.3254 10.877 68.3254 9.99999C68.3254 9.12299 68.6194 8.38099 69.2094 7.77499C69.7984 7.16899 70.5314 6.86499 71.4084 6.86499C72.2804 6.86499 73.0124 7.16999 73.6044 7.77899C74.1964 8.38799 74.4924 9.12799 74.4924 9.99999C74.4924 10.877 74.1974 11.619 73.6084 12.225ZM69.7784 11.722C70.2224 12.172 70.7654 12.396 71.4084 12.396C72.0514 12.396 72.5954 12.171 73.0384 11.722C73.4824 11.272 73.7054 10.698 73.7054 9.99999C73.7054 9.30199 73.4824 8.72799 73.0384 8.27799C72.5954 7.82799 72.0514 7.60399 71.4084 7.60399C70.7654 7.60399 70.2224 7.82899 69.7784 8.27799C69.3354 8.72799 69.1124 9.30199 69.1124 9.99999C69.1124 10.698 69.3354 11.272 69.7784 11.722Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5745 13V7H76.5125L79.4285 11.667H79.4615L79.4285 10.511V7H80.1995V13H79.3945L76.3435 8.106H76.3105L76.3435 9.262V13H75.5745Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_15380_55697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4357 7.53797C10.1447 7.84597 9.97266 8.32397 9.97266 8.94297V31.059C9.97266 31.679 10.1447 32.156 10.4357 32.464L10.5097 32.536L22.8987 20.147V20.001V19.855L10.5097 7.46497L10.4357 7.53797Z",
    fill: "url(#paint0_linear_15380_55697)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0274 24.278L22.8984 20.147V20.001V19.855L27.0284 15.725L27.1214 15.778L32.0144 18.558C33.4114 19.352 33.4114 20.651 32.0144 21.446L27.1214 24.226L27.0274 24.278Z",
    fill: "url(#paint1_linear_15380_55697)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_15380_55697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1215 24.225L22.8975 20.001L10.4355 32.464C10.8955 32.952 11.6565 33.012 12.5135 32.526L27.1215 24.225Z",
    fill: "url(#paint2_linear_15380_55697)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.1215 15.7769L12.5135 7.47694C11.6565 6.98994 10.8955 7.05094 10.4355 7.53894L22.8985 20.0019L27.1215 15.7769Z",
    fill: "url(#paint3_linear_15380_55697)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 134,
    height: 39,
    rx: 4.5,
    stroke: "#212121"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_15380_55697",
    x: 9.97266,
    y: 7.14087,
    width: 23.0898,
    height: 25.7208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_15380_55697"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_15380_55697",
    result: "effect2_innerShadow_15380_55697"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_15380_55697",
    x: 10.4355,
    y: 20.001,
    width: 16.6855,
    height: 12.8607,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_15380_55697"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15380_55697",
    x1: 21.8005,
    y1: 8.70897,
    x2: 5.01846,
    y2: 25.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15380_55697",
    x1: 33.8329,
    y1: 20.001,
    x2: 9.63704,
    y2: 20.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15380_55697",
    x1: 24.8276,
    y1: 22.2949,
    x2: 2.06915,
    y2: 45.0534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15380_55697",
    x1: 7.29695,
    y1: 0.176745,
    x2: 17.4592,
    y2: 10.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.4df06d46b97df74f21677bf4eda49c81.svg";
export { ForwardRef as ReactComponent };